<template>
  <div class="l-edit-dialog-box" style="height: 90vh; max-height: 80vh; padding-bottom: 0">
    <div class="l-table-toolbar">
      <el-button type="danger" :disabled="select_assets_ids.length == 0" @click="clearAll">清空选择</el-button>
      <div class="l-simple-search-container" style="margin-bottom: 10px">
        <el-input placeholder="搜索资产名称/资产编号" v-model="search_data.keywords" class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
        </el-input>

        <div class="l-show-more-search" @click="showSearch">
          <i class="ri-align-center"></i>
          <span>高级搜索</span>
        </div>
      </div>
    </div>
    <l-table :data="data" :offset-height="offsetHeight" ref="table" @selection-change="handleSelectionChange" row-key="id">
      <el-table-column type="selection" width="45" reserve-selection> </el-table-column>
      <el-table-column prop="dev_no" label="资产编号" min-width="150"></el-table-column>
      <el-table-column prop="dev_name" label="资产名称" min-width="150"></el-table-column>
      <el-table-column label="资产状态" min-width="80">
        <template v-slot="{ row }">
          <l-assets-state :state="row.dev_state"></l-assets-state>
        </template>
      </el-table-column>
      <el-table-column prop="dev_type_id" label="资产类型" min-width="150">
        <template v-slot="{ row }"> {{ row.p_dev_type_name }} - {{ row.dev_type_name }} </template>
      </el-table-column>
      <el-table-column prop="manage_org_name" label="管理组织" min-width="100" show-overflow-tooltip></el-table-column>
      <el-table-column prop="manage_user_name" label="管理人" min-width="100" show-overflow-tooltip></el-table-column>
      <el-table-column prop="use_org_name" label="使用组织" min-width="150" show-overflow-tooltip></el-table-column>
      <el-table-column prop="use_user_name" label="使用人" min-width="100" show-overflow-tooltip></el-table-column>

      <el-table-column prop="hall_name" label="营业厅/办公点" min-width="200" show-overflow-tooltip></el-table-column>
      <el-table-column label="存放区域" min-width="200" show-overflow-tooltip>
        <template v-slot="{ row }">
          {{ row.prov + row.city + row.area }}
        </template>
      </el-table-column>
      <el-table-column prop="address" label="详细地址" min-width="250" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="entry_date" label="入库时间" min-width="110" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="entry_date" label="金额" min-width="150" show-overflow-tooltip>
        <template v-slot="{ row }">
          <span v-show="row.dev_value"> {{ row.dev_value }}元 </span>
        </template>
      </el-table-column>
    </l-table>
    <!--分页-->
    <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size" :current-page.sync="page"></l-page>

    <!--高级搜索-->
    <el-drawer title="高级搜索" class="l-search-drawer" v-loading="search_loading" :modal="false" :visible.sync="search_visible" size="400px" :append-to-body="false" :modal-append-to-body="false" z-indx="-1">
      <div class="l-search-drawer-body">
        <el-form label-width="110px" ref="search_form" :model="search_data">
          <el-form-item label="资产编号" prop="dev_no">
            <el-input v-model="search_data.dev_no" placeholder="资产编号"></el-input>
          </el-form-item>
          <el-form-item label="资产名称" prop="dev_name">
            <el-input v-model="search_data.dev_name" placeholder="资源名称"></el-input>
          </el-form-item>
          <!-- <el-form-item label="资产状态" prop="dev_state">
						<el-select v-model="search_data.dev_state" placeholder="请选择资产状态" clearable>
							<el-option :label="item.name" :value="item.value" v-for="item in states" :key="item.value"> </el-option>
						</el-select>
					</el-form-item> -->
          <el-form-item label="资产类型" prop="dev_type_id">
            <el-cascader placeholder="请选择资产类型" :options="dev_tree" filterable v-model="search_data.dev_type_id" clearable></el-cascader>
          </el-form-item>

          <el-form-item label="营业厅/办公点" prop="hall_id">
            <el-select v-model="search_data.hall_id" filterable placeholder="请选择营业厅/办公点" clearable>
              <el-option v-for="item in hall_list" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>

          <div class="l-cust-select">
            <el-form-item prop="manage_org_id" label="管理组织">
              <el-select ref="s_manage_org_id" v-model="search_data.manage_org_id" placeholder="请选择管理组织" clearable @clear="curr_manage_org_name = ''">
                <el-option :value="search_data.manage_org_id" :label="curr_manage_org_name" style="height: auto; padding: 0">
                  <el-tree ref="manage_org_id" :data="org_tree" default-expand-all :expand-on-click-node="false" node-key="id" highlight-current :props="defaultProps"
                    @node-click="(data) => handleOrgSelect(data, 'manage_org_id', 'curr_manage_org_name')" :current-node-key="search_data.manage_org_id"></el-tree>
                </el-option>
              </el-select>
            </el-form-item>
          </div>

          <el-form-item label="管理员" prop="manage_user_id">
            <el-select v-model="search_data.manage_user_id" filterable placeholder="请选择管理员" clearable>
              <el-option v-for="item in mange_user_list" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>

          <div class="l-cust-select">
            <el-form-item prop="use_org_id" label="使用组织">
              <el-select ref="s_use_org_id" v-model="search_data.use_org_id" placeholder="请选择使用组织" clearable @clear="curr_use_org_name = ''">
                <el-option :value="search_data.use_org_id" :label="curr_use_org_name" style="height: auto; padding: 0">
                  <el-tree ref="use_org_id" :data="org_tree" default-expand-all :expand-on-click-node="false" node-key="id" highlight-current :props="defaultProps"
                    @node-click="(data) => handleOrgSelect(data, 'use_org_id', 'curr_use_org_name')" :current-node-key="search_data.use_org_id"></el-tree>
                </el-option>
              </el-select>
            </el-form-item>
          </div>

          <el-form-item label="使用人" prop="use_user_id">
            <el-select v-model="search_data.use_user_id" filterable placeholder="请选择管理员" clearable>
              <el-option v-for="item in use_user_list" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item label="存放区域" prop="addr">
						<el-cascader v-model="search_data.addr" :options="addr_tree" filterable placeholder="请选择存放区域(可搜索，如输入”成都“)" clearable></el-cascader>
					</el-form-item> -->
        </el-form>
      </div>

      <div class="l-search-drawer-footer">
        <el-button type="normal" @click="onReset">重置</el-button>
        <el-button type="primary" @click="onSearch">搜索</el-button>
      </div>
    </el-drawer>

    <div class="l-dialog-footer">
      <span style="margin-right: 10px"> 已选{{ select_assets_ids.length }}项</span>
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </div>
  </div>
</template>

<script>
import { getValue } from "../../utils/Fuc";
import States from "./States.vue";
import { states } from "./states.js";
import Vue from "vue";
export default {
  name: "l-assets-common-select",
  components: {
    [States.name]: States,
  },
  props: {
    visible: {
      type: Boolean,
    },
    //类型，1领用  2退还  3借用 4归还
    type: {
      type: Number,
      required: true,
    },

    selectIds: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },

  data() {
    return {
      data: [],
      count: 0,
      page: 1,
      page_size: Vue.$_config.page.page_size,
      loading: false,

      table_height: 0,
      offsetHeight: 100,

      //搜索
      search_visible: false,
      search_loading: true,
      search_loaded: false,
      dev_tree: [],
      curr_use_org_name: "",
      curr_manage_org_name: "",
      org_tree: [],
      addr_tree: [],
      user_list: [],
      hall_list: [],
      mange_user_list: [],
      use_user_list: [],
      states: states,
      defaultProps: {
        children: "children",
        label: "name",
      },
      search_data: {
        keywords: "",
        dev_no: "",
        dev_name: "",
        dev_state: "",
        dev_type_id: [],
        use_org_id: "",
        use_user_id: "",
        manage_org_id: "",
        manage_user_id: "",
        hall_id: "",
        addr: [],
        not_in_ids: [],
      },
      rel_search_data: {},
      show_more_search: false,

      submitting: false, //是否正在提交
      select_assets_ids: [], //已选中的设备Id
      select_data: [], //已选中的数据
    };
  },

  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.$nextTick(() => {
              this.getSearchData(true);
              this.setSearchData();
              this.onSearch();
            });
          });
        }
      },
    },

    "search_data.use_org_id"() {
      this.search_data.use_user_id = "";

      //重新获取使用人用户列表
      this.getUserListByOrg(this.search_data.use_org_id, "use_user_list");
    },

    "search_data.manage_org_id"() {
      this.search_data.manage_user_id = "";

      //重新获取管理人用户列表
      this.getUserListByOrg(this.search_data.manage_org_id, "mange_user_list");
    },
  },

  mounted() {
    this.offsetHeight = this.$refs.table.$el.offsetTop + 60;
  },

  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit("update:visible", false);
    },

    //预先设置搜索条件
    setSearchData() {
      if (this.$props.type == 1) {
        //获取可领用的数据
        this.search_data.not_in_ids = this.$props.selectIds;
        this.search_data.dev_state = 1; //查闲置状态的资产
      } else if (this.$props.type == 2) {
        //获取可退还的数据
        this.search_data.not_in_ids = this.$props.selectIds;
        this.search_data.dev_state = 2; //查使用中的资产
      } else if (this.$props.type == 3) {
        //获取可借用的数据
        this.search_data.not_in_ids = this.$props.selectIds;
        this.search_data.dev_state = 1; //查闲置状态的资产
      } else if (this.$props.type == 4) {
        //获取借用中的数据
        this.search_data.not_in_ids = this.$props.selectIds;
        this.search_data.dev_state = 4; //查闲置状态的资产
      } else if (this.$props.type == 5) {
        //获取闲置中的数据
        this.search_data.not_in_ids = this.$props.selectIds;
        this.search_data.dev_state = 1; //查闲置状态的资产
      } else if (this.$props.type == 6) {
        //获取不在审核/处置状态的资产
        this.search_data.not_in_ids = this.$props.selectIds;
        this.search_data.not_dev_state = [3, 5]; //查不是审核/处置状态的资产
      } else {
        this.search_data.not_in_ids = this.$props.selectIds;
      }
    },

    //获取高级搜索的搜索数据
    getSearchData() {
      if (this.search_loaded) return;
      this.$_invoke("assets_getSearchData", {}).then((ret) => {
        this.loading = false;
        this.search_loaded = true;
        // this.user_list = ret.user_list;
        this.addr_tree = ret.addr_tree;
        this.org_tree = ret.org_tree;
        this.hall_list = ret.hall_list;

        ret.dev_tree.forEach((item) => {
          const children = getValue(item, "children");
          if (children && children.length > 0) {
            this.dev_tree.push(item);
          }
        });
      });
    },

    //点击显示高级搜索
    showSearch() {
      this.search_visible = true;
      this.getSearchData();
    },

    //获取数据
    getList() {
      this.$_invoke("assets_getList", {
        page: this.page,
        page_size: this.page_size,
        ...this.rel_search_data,
      })
        .then((ret) => {
          this.data = ret.data;
          this.count = ret.count;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //选择使用机构
    handleOrgSelect(data, form_filed, name_filed) {
      this.search_data[form_filed] = data.id;
      this[name_filed] = data.name;
      this.$refs[form_filed].setCurrentKey(data.id);
      this.$refs["s_" + form_filed].blur();
    },

    //获取用户列表
    getUserListByOrg(org_id, user_list) {
      this.$_invoke("user_getListByOrg", { org_id }).then((ret) => {
        this[user_list] = ret.data;
      });
    },
    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.rel_search_data = this.search_data;
      this.getList();
    },

    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.search_data.use_org_id = "";
      this.curr_use_org_name = "";
      this.rel_search_data = {};
    },

    //监听复选框选择
    handleSelectionChange(val) {
      const select_ids = [];
      this.select_data = val;
      val.forEach((item) => {
        select_ids.push(item.id);
      });

      this.select_assets_ids = select_ids;
    },

    //清空所有选择
    clearAll() {
      this.$refs.table.clearSelection();
      this.$_msg.success("清空成功");
    },

    //保存已选项
    handleSubmit() {
      this.submitting = true;
      this.$emit("on-select", this.select_assets_ids, this.select_data);
    },
  },
};
</script>
